import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { DocLanguageBar } from "./DocLanguageBar";
import { DOC_COLORS, DOC_TYPES as TYPES } from "./docTypes";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { OfficialMinutes } from "../official/OfficialMinutes";
import { GenericDocEditor } from "./GenericDocEditor";

const DEFAULT = { official_my: "official", lecture: "lecture" };

export const DocumentsTab = ({ meeting, canWrite, initialKind }) => {
  const { L } = useApp();
  const [docs, setDocs] = useState(null);
  const [ver, setVer] = useState(0);
  const [kind, setKind] = useState(initialKind || meeting.doc_type || DEFAULT[meeting.template] || null);
  useEffect(() => {
    api.get(`/meetings/${meeting.id}/documents`).then((r) => {
      setDocs(r.data);
      setKind((k) => k || TYPES.map((t) => t[0]).find((t) => r.data[t]) || "official");
    });
  }, [meeting.id]);
  if (!docs || !kind) return null;
  const t = TYPES.find((x) => x[0] === kind);
  return (
    <div className="space-y-5" data-testid="documents-tab">
      <div>
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">{L("Tukar transkrip kepada", "Convert transcript into")}</p>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" role="tablist">
          {TYPES.map(([k, Icon, title, desc]) => (
            <button key={k} role="tab" aria-selected={kind === k} onClick={() => setKind(k)} data-testid={`doc-type-${k}`}
              className={`relative rounded-2xl border p-4 text-left transition-colors ${kind === k ? DOC_COLORS[k][1] : DOC_COLORS[k][0]}`}>
              {docs[k] && <CheckCircle2 size={16} className="absolute right-3 top-3 text-emerald-500" data-testid={`doc-type-${k}-ready`} />}
              <Icon size={20} className={DOC_COLORS[k][2]} />
              <p className="mt-2 font-heading text-sm font-bold text-slate-900">{L(...title)}</p>
              <p className="mt-1 text-xs leading-snug text-slate-500">{L(...desc)}</p>
            </button>
          ))}
        </div>
      </div>
      {docs[kind] && <DocLanguageBar meetingId={meeting.id} kind={kind} doc={docs[kind]} canWrite={canWrite} onTranslated={(d) => { setDocs((x) => ({ ...x, [kind]: d })); setVer((v) => v + 1); }} />}
      {kind === "official"
        ? <OfficialMinutes key={`off-${ver}`} meeting={meeting} canWrite={canWrite} onChanged={(d) => setDocs((x) => ({ ...x, official: d }))} />
        : <GenericDocEditor key={`${kind}-${ver}`} meeting={meeting} kind={kind} doc={docs[kind]} setDoc={(d) => setDocs((x) => ({ ...x, [kind]: d }))} canWrite={canWrite} info={{ title: L(...t[2]), desc: L(...t[3]) }} />}
    </div>
  );
};
